'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { noop } from 'lodash';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AlertTitle from '@mui/material/AlertTitle';
import { Logger } from '../../lib/logger';
const timeoutHandler = async (timeout, onClick) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(onClick);
        }, timeout);
    });
};
export default function AlertControl({ title, type, message, action = null, dismissable = false, onClick = noop, timeout, sx = {} }) {
    useEffect(() => {
        timeout && timeoutHandler(timeout, onClick);
    }, []);
    const handleActionClick = () => {
        Logger.log('handleActionClick');
        action?.onClick && action.onClick();
        onClick();
    };
    const actionBlock = action ? (_jsx(Button, { onClick: handleActionClick, sx: sx.action, children: action.label }, action.label)) : null;
    const alertProps = {
        severity: type,
        sx: sx.root
    };
    action && (alertProps.action = actionBlock);
    dismissable && (alertProps.onClose = onClick);
    return (_jsxs(Alert, { ...alertProps, children: [title && _jsx(AlertTitle, { sx: sx.title, children: title }), message && (_jsx(Typography, { variant: "body1", sx: sx.message, children: message }))] }));
}
